/**
 * Image utility functions for handling base URL paths
 */

/**
 * Gets the full URL for an image asset with proper base path handling
 * @param imagePath - The image path relative to public folder (e.g., '/logo.png')
 * @returns Full URL with base path included
 */
export const getImageUrl = (imagePath: string): string => {
  const baseUrl = import.meta.env.BASE_URL;
  
  // Remove leading slash from imagePath if it exists
  const cleanImagePath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  // Remove trailing slash from baseUrl if it exists
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  return `${cleanBaseUrl}/${cleanImagePath}`;
};

/**
 * Gets the logo URL with proper base path
 * @returns Full logo URL with base path
 */
export const getLogoUrl = (): string => {
  return getImageUrl('/logo.png');
};
